import { useRef } from 'react';
import useInlineScript from '@/hooks/useInlineScript';
import { type IEmbedDatawrapper } from '@/types/IEmbeds';
import styles from './index.module.scss';

export default function Datawrapper ({
  height,
  id,
  width,
}: IEmbedDatawrapper) {
  const ref = useRef<HTMLDivElement>(null);

  useInlineScript(ref, '<script type="text/javascript">window.addEventListener("message",function(a){if(void 0!==a.data["datawrapper-height"]){var e=document.querySelectorAll("iframe");for(var t in a.data["datawrapper-height"])for(var r,i=0;r=e[i];i++)if(r.contentWindow===a.source){var d=a.data["datawrapper-height"][t]+"px";r.style.height=d}}});</script>');

  return (
    <div className={styles['datawrapper']} ref={ref}>
      <iframe
        height={height}
        src={id}
        style={{ border: 'none', minWidth: '100% !important' }}
        width={width}
      />
    </div>
  );
}
